export const PHASES = ['brand', 'model', 'version'];
export const VEHICLE_STATUS = {
  NEW: 'new',
  OLD: 'old',
};

export const STORE_NAME = 'carInstance';

export * from './actions';
export * from './fields';
export * from './legacy';
